import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "form-popup"
};
const _hoisted_2 = {
  class: "popup-main"
};
const _hoisted_3 = {
  class: "popup-header"
};
const _hoisted_4 = {
  class: "popup-content"
};
const _hoisted_5 = {
  class: "input-row"
};
const _hoisted_6 = {
  class: "input-box width-auto"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "input-text"
}, "+63", -1);
const _hoisted_8 = {
  class: "input-box"
};
const _hoisted_9 = {
  class: "input-row"
};
const _hoisted_10 = {
  class: "input-box"
};
const _hoisted_11 = {
  class: "suffix-wrap"
};
const _hoisted_12 = {
  class: "input-extra flex justify-between"
};
const _hoisted_13 = {
  key: 0,
  class: "bonus-wrap"
};
import { ref, reactive, computed, onUnmounted } from 'vue';
import { useRouter } from 'vue-router';
import md5 from 'js-md5';
import ws from '@/connect';
import { useFBQ } from '@/hooks';
import { useUserStore } from '@/store';
import { login } from "@/api";
export default {
  __name: 'Login',
  props: ['registerReward'],
  emits: ['onClose', 'onShowForgetPwd', 'onShowRegister'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const router = useRouter();
    const userStore = useUserStore();
    const form = reactive({
      phone: '',
      password: ''
    });
    const showPassword = ref(false);
    const loginDisabled = computed(() => {
      return form.phone.length < 10 || form.password.length < 6;
    });
    const doLogin = () => {
      login({
        username: form.phone,
        password: md5(form.password)
      }).then(res => {
        let userData = res.data || {};
        userStore.setUserInfo(userData);
        userStore.setLoginInit(true);
        ws.connect();
        useFBQ().registerEvent('TEST18691');
        goToHome();
      });
    };
    const inputBlur = e => {
      let field = e.target.name;
      if (field) {
        form[field] = form[field].replace(/ +/g, '');
      }
    };
    const goToHome = () => {
      router.push({
        name: 'game'
      });
    };
    return (_ctx, _cache) => {
      const _component_van_image = _resolveComponent("van-image");
      const _component_van_field = _resolveComponent("van-field");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_button = _resolveComponent("van-button");
      const _component_van_form = _resolveComponent("van-form");
      const _component_van_popup = _resolveComponent("van-popup");
      const _directive_audio = _resolveDirective("audio");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_popup, {
        show: true,
        "close-on-click-overlay": false,
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('user.accountLogin')), 1), _withDirectives(_createVNode(_component_van_image, {
          class: "close-icon",
          src: require('@/assets/img/common/popup-close.png'),
          onClick: _cache[0] || (_cache[0] = $event => emit('onClose'))
        }, null, 8, ["src"]), [[_directive_audio, void 0, "close"]])]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_form, {
          class: "input-form style1",
          onSubmit: doLogin
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_van_image, {
            class: "input-icon",
            fit: "contain",
            src: require('@/assets/img/user/form/phone.png')
          }, null, 8, ["src"]), _hoisted_7]), _createElementVNode("div", _hoisted_8, [_createVNode(_component_van_field, {
            modelValue: form.phone,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.phone = $event),
            name: "phone",
            class: "input-field",
            placeholder: _ctx.$t('placeholder.mobilePhone'),
            type: "digit",
            onBlur: inputBlur,
            maxlength: "11",
            clearable: ""
          }, null, 8, ["modelValue", "placeholder"])])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_van_image, {
            class: "input-icon",
            fit: "contain",
            src: require('@/assets/img/user/form/lock.png')
          }, null, 8, ["src"]), _createVNode(_component_van_field, {
            modelValue: form.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.password = $event),
            name: "password",
            class: "input-field",
            placeholder: _ctx.$t('placeholder.password'),
            type: !showPassword.value ? 'password' : 'text',
            onBlur: inputBlur,
            maxlength: "12",
            clearable: ""
          }, null, 8, ["modelValue", "placeholder", "type"]), _createElementVNode("div", _hoisted_11, [_withDirectives(_createVNode(_component_van_icon, {
            class: "eye-icon",
            name: !showPassword.value ? 'eye-o' : 'closed-eye',
            onClick: _cache[3] || (_cache[3] = $event => showPassword.value = !showPassword.value)
          }, null, 8, ["name"]), [[_directive_audio]])])])]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
            onClick: _cache[4] || (_cache[4] = $event => emit('onShowForgetPwd'))
          }, _toDisplayString(_ctx.$t('user.forgetPassword')), 1), _createElementVNode("div", {
            onClick: _cache[5] || (_cache[5] = $event => {
              emit('onShowRegister');
            })
          }, _toDisplayString(_ctx.$t('common.register')), 1), __props.registerReward ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('welcome.registerRewrad')) + " " + _toDisplayString(__props.registerReward) + "PHP", 1)) : _createCommentVNode("", true)]), _withDirectives((_openBlock(), _createBlock(_component_van_button, {
            "native-type": "submit",
            class: "submit-btn",
            block: "",
            disabled: loginDisabled.value
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('common.login')), 1)]),
            _: 1
          }, 8, ["disabled"])), [[_directive_audio]])]),
          _: 1
        })])])]),
        _: 1
      })]);
    };
  }
};